/// need to uncomment if azure required
// import { loginRequest } from "../authConfig.js";
// import { PublicClientApplication } from "@azure/msal-browser";
// import { msalConfig } from "../authConfig";

// Stub export for when Azure is not required
export const refreshAccessToken = async () => {
    return null;
};

// export const refreshAccessToken = async () => {

//     const msalInstance = new PublicClientApplication(msalConfig);

//     const account = msalInstance.getAllAccounts();
//     try {
//         const token = await msalInstance.acquireTokenSilent({
//             scopes: loginRequest.scopes,
//             // account: msalInstance.getAccountByUsername(account[0].username),
//             account: account[0],
//         });
//         return token.accessToken;
//     } catch (error) {
//         if (error) {
//             return msalInstance
//                 .acquireTokenPopup(loginRequest)
//                 .then((resp) => {
//                     return resp.accessToken;
//                 })
//                 .catch((err) => {
//                     return null;
//                 });
//         } else {
//             console.error(error);
//         }
//     }
/// };